<template>
  <div class="input-with-icon">
    <v-text-field
        v-model="searchText"
        class="search-field"
        dense
        :variant="variant ? variant : 'plain'"
        hide-details
        :placeholder="placeholder ? placeholder : 'Rechercher'"
        @focus="isSearchInputFocused=true"
        @blur="onSearchInputBlur"
        @keyup.enter="onSearchInputBlur">
      <template #prepend-inner>
        <v-icon class="search-icon">
          fas fa-magnifying-glass
        </v-icon>
      </template>
      <template #append-inner>
        <v-icon class="clear-icon" @click="clearSearchText()">
          fas fa-xmark
        </v-icon>
      </template>
    </v-text-field>
  </div>


</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  props: {
    withFilterItemsThatHaveAlerts: {
      type: Boolean
    },
    localStorageKey: {
      type: String,
      required: false
    },
    value: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    variant: {
      type: String,
    }
  },
  data() {
    const searchedTerms: string[] = [];

    return {
      text: "",
      fItemsThatHaveAlert: false,
      isSearchInputFocused: false,
      searchedTerms
    };
  },
  computed: {
    searchText: {
      get(): string {
        let res = "";
        if (this.value) {
          res = this.value;
        } else {
          res = this.text;
        }
        return res;
      },
      set(v: string) {
        this.text = v;
        this.$emit('inputUpdated', v);
      }
    }
  },
  mounted(): void {
    if (this.localStorageKey) {
      const t = localStorage.getItem(this.localStorageKey);
      if (t) {
        this.searchedTerms = JSON.parse(t);
      }
    }
  },
  methods: {
    clearSearchText() {
      this.text = "";
      this.$emit('inputUpdated', this.text);
    },
    toggleFilterItemsThatHaveAlert(): void {
      this.fItemsThatHaveAlert = !this.fItemsThatHaveAlert;
      this.$emit('filterItemsThatHaveAlertUpdated', this.fItemsThatHaveAlert);
    },
    setSearchText(term: string): void {
      this.searchText = term;
    },
    onSearchInputBlur(): void {
      setTimeout(() => {
            this.isSearchInputFocused = false;
            this.saveTermLocally();
          },
          300
      );
    },
    saveTermLocally(): void {
      if (this.text != '' && !this.searchedTerms.includes(this.text) && this.localStorageKey) {
        this.searchedTerms.push(this.text);
        localStorage.setItem(this.localStorageKey, JSON.stringify(this.searchedTerms));
      }
    }
  }
})

</script>

<style scoped>
.search-icon {
  padding-top: 3px;
  padding-left: 5px;
}

.clear-icon {
  color: #C6CED2;
  padding: 5px;
  padding-bottom: 0;
}
</style>